import { FC } from 'react';

import PortalHeader from 'components/PortalHeader/PortalHeader';

type HeaderProps = {
    onAddCoupon: () => void;
    isCouponsEnabled: boolean;
    canUserEdit: boolean;
    canManageCoupons: boolean;
};

const Header: FC<HeaderProps> = ({
    onAddCoupon,
    isCouponsEnabled,
    canUserEdit,
    canManageCoupons
}) => {
    return (
        <PortalHeader
            title="Coupons"
            primaryButtonText='Add New Coupon'
            onPrimaryButtonClick={onAddCoupon}
            isCreateButton
            primaryButtonState={{
                disabled: !canUserEdit || !isCouponsEnabled,
                hidden: !canManageCoupons
            }}
            dataTestId="CouponsHeader"
            className="pt-8 mb-2"
        />
    );
};

export default Header;
